import { useEffect,useState } from "react";
import styled from "styled-components";
import axios from "axios";
import {url,setHeaders} from "../../features/api"
import { useParams } from "react-router-dom";
import{toast} from"react-toastify"
const UserProfile = () => {
    const params=useParams()
    const[loading,setLoading]=useState(false)
     const[updating,setUpdating]=useState(false)
    const[user,setUser]=useState({
        name:"",
        email:"",
        isAdmin:"",
        password:"",
        
    })

    useEffect(()=>{
        const fetchUser=async()=>{
            try{
                setLoading(true)

           const response=axios.get(`${url}/users/users/find/${params.id}`,setHeaders())
           setUser({...(await response).data,password:""})
           
            }catch(err){
                
            }
        }
        fetchUser()
        setLoading(false)
        

    },[params])
     const handleSubmit=async(e)=>{
      setUpdating(true)
      try{
        const res=await axios.put(`${url}/users/users/${params.id}`,{...user},setHeaders())
        console.log(res)
        setUser({...res.data,password:""})
           toast.success("User profile updated",{
            position:"top-center"
           })

        
      }
      catch(error){
        console.log(error)

      }

setUpdating(false)
    }


  return <StyledProfile><ProfileContainer>{ loading?<p>Loading....</p>:(
  <form onSubmit={(e)=> handleSubmit()}>

        <h2>User Profile</h2>
        {user.isAdmin?<Admin>Admin</Admin>:<Customer>Customer</Customer>}
        Name:
        <input
          type="text"
          value={user.name}
          onChange={(e) => setUser({ ...user, name: e.target.value })}
          placeholder="name"
        />
        Email:
        <input
          type="email"
          value={user.email}
          onChange={(e) => setUser({ ...user, email: e.target.value })}
          placeholder="email"
        />
        Password:
        <input
          value={user.password}
          type="password"
          onChange={(e) => setUser({ ...user, password: e.target.value })}
        />
        <button type="submit">
          {updating?"updating":"update profile"}
        </button>
      </form>
)}</ProfileContainer></StyledProfile>;
};

export default UserProfile;
const StyledProfile = styled.div`
  margin: 3rem;
  display: flex;
  justify-content: center;
`;

const ProfileContainer = styled.div`
  max-width: 500px;
  width: 100%;
  height: auto;
  display: flex;
  box-shadow: Orgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border-radius: 5px;
  padding: 2rem;
  form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    h3 {
      margin-bottom: 0.5rem;
    }
    label {
      margin-bottom: 0.2em;
      color: gray;
    }
    input {
      margin-bottom: 1em;
      outline: none;
      border: none;
      border-bottom: 1px solid gray;
    }
  }
`;
const Admin = styled.div`
  color: rgb(253, 181, 40);
  background: rgb(253, 181, 40, 0.12);
  padding: 3px 5px;
  border-radius: 3px;
  font-size: 14;
  margin-bottom: 1rem;
`;
const Customer = styled.div`
  color: rgb(38, 198, 249);
  background: rgb(38, 198, 249, 0.12);
  padding: 3px 5px;
  border-radius: 3px;
  font-size: 14;
  margin-bottom: 1rem;
`;
